export default __webpack_public_path__ + "static/media/periodontics.a6ae7336.svg";